var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getRouteName === 'referral-program')?_c('terms-and-conds-referral-program'):_c('page-not-found')
}
var staticRenderFns = []

export { render, staticRenderFns }